import styled from 'styled-components'
import Button from 'common-components/button'
import Icon from 'e-submission/components/Icon'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { startVideoConsent } from 'quick-quote/remote-selling/actions'
import { debounce } from 'lodash/fp'
import { isLoading } from 'quick-quote/ui/selectors'
import { setAppValue, openNative } from 'e-submission/apps/actions'
import { getRemoteSellingCaseId, getRemoteSellingState } from 'e-submission/domain/data-model/form/selectors'
import ResumeRMS from 'e-submission/containers/Dialog/ResumeRMS'
import SendLinkRoomIdNotExist from 'e-submission/containers/Dialog/SendLinkRoomIdNotExist'
import _ from 'lodash'
import VideoConsentWarning from 'e-submission/containers/Dialog/VideoConsentWarning'
import React from 'react'
import IdentifyEkycResponding from 'e-submission/containers/Dialog/IdentifyEkycResponding'
import { confirmUsingRemoteSelling } from 'core/actions'

const BgWhite = styled.div`
  background-color: white;
  padding: 0.75rem;
  line-height: 1rem;
  font-size: 0.875rem;
  margin-bottom: 1rem;
`

const Container = styled.div`
  text-align: center;
  margin-bottom: 0.75rem;
`

export const Heading = styled.div`
  font-weight: bold;
  font-size: 1.333rem;
  margin-bottom: 1rem;

  label {
    display: inline !important;
    padding-left: 0.5rem;
  }
`

const SubHeading = styled.label`
  display: block;
  font-size: 1rem;
  font-weight: bold;
`

const VideoConsent = ({
  loading,
  onClick,
  isInCall,
  caseId,
  openNative,
  openResumeCaseModal,
  creatingRemoteSellingCaseStatus,
  isModalCreatingRemoteSellingOpen,
  closeCreatingRemoteSellingCaseModal,
}) => {
  let text
  let _onClick
  if (isInCall) {
    text = 'บันทึกภาพและเสียง'
    _onClick = onClick
  } else {
    text = 'เข้าสู่การขายแบบ Remote Selling'
    _onClick = () => {
      openResumeCaseModal()
    }
  }

  let button = (
    <Container>
      <Button disabled={loading} loading={loading.toString()} onClick={_onClick}>
        {text}
      </Button>
    </Container>
  )

  return (
    <div>
      <VideoConsentWarning />
      <Heading>
        <Icon.video />
        <label>บันทึกภาพให้ความยินยอม</label>
      </Heading>
      <BgWhite>
        <SubHeading>กรุณาเปิดไมค์เพื่อบันทึกภาพและเสียงให้ความยินยอม สำหรับผู้เอาประกัน</SubHeading>
      </BgWhite>
      <BgWhite>
        <label>
          เพื่อให้เป็นไปตามหลักเกณฑ์การเสนอขายของสำนักงานคณะกรรมการกำกับและส่งเสริมการประกอบธุรกิจประกันภัย
          ในการเสนอขายกรมธรรม์ประกันชีวิตผ่านระบบ Remote selling
          มีความจำเป็นในการบันทึกการตอบตกลงแจ้งความประสงค์เพื่อยืนยันการสมัครทำประกันภัยของลูกค้า บริษัทฯ
          จึงขออนุญาตบันทึกการยืนยันดังกล่าวในรูปแบบเสียง หรือ ภาพและเสียง เพื่อให้เป็นไปตามหลักเกณฑ์
          และเพื่อประโยชน์ของลูกค้าในการสมัครทำประกันชีวิต
        </label>
      </BgWhite>
      {button}
      <ResumeRMS sectionName={'videoConsent'} />
      <SendLinkRoomIdNotExist />
      <IdentifyEkycResponding
        isDuplicate={false}
        insuredOrPayer={''}
        identifyEkycRespond={creatingRemoteSellingCaseStatus}
        isReuseCase={false}
        isOpen={isModalCreatingRemoteSellingOpen}
        onExit={() => {
          closeCreatingRemoteSellingCaseModal()
        }}
        onSubmit={() => {
          closeCreatingRemoteSellingCaseModal()
          if (caseId) {
            openNative(caseId, 'none')
          }
        }}
        isRemoteSellingRespond
      />
    </div>
  )
}

const mapDispatchToProps = (dispatch) => ({
  onClick: debounce(750, () => {
    dispatch(startVideoConsent())
  }),
  openResumeCaseModal: () => {
    dispatch(confirmUsingRemoteSelling())
  },
  openNative: (caseId, nextProcess, push = true) => {
    dispatch(
      openNative({
        caseId,
        nextProcess,
        push,
        resume: true,
      })
    )
  },
  closeCreatingRemoteSellingCaseModal: () => {
    dispatch(setAppValue(`remoteSelling.isModalCreatingRemoteSellingOpen`, false))
  },
})
export default (hoc) =>
  compose(
    connect((state) => {
      const currentAppId = _.get(state, 'apps.currentAppId')
      const appData = _.get(state, `apps.byId[${currentAppId}]`)
      const caseId = getRemoteSellingCaseId(appData)
      const remoteSellingState = getRemoteSellingState(appData)
      const isInCall = remoteSellingState.callStatus ? remoteSellingState.callStatus.isInCall : false

      return {
        loading: isLoading(state),
        caseId,
        creatingRemoteSellingCaseStatus: remoteSellingState.creatingRemoteSellingCaseStatus,
        isModalCreatingRemoteSellingOpen: remoteSellingState.isModalCreatingRemoteSellingOpen,
        isInCall,
      }
    }, mapDispatchToProps),
    hoc
  )(VideoConsent)
